/* Ny filnavn 01.10.2026 (Claude): samme kode som lipscore-cards.js / mm-lipscore-lazy.js, men nytt navn fordi Shopifys CDN fortsatte å sende den gamle versjonen etter API-oppdatering. */
/**
 * Lat lasting av Lipscore-widgets (Claude 27.09.2026, rettet 30.09.2026).
 *
 * Elementer med data-mm-lipscore-lazy="<klasse>" (og eventuelt data-mm-lipscore-lazy-id="<id>") rendres
 * uten Lipscore-klassen og -ID-en, så Lipscore ignorerer dem. Når elementet er innenfor ca. 1,5
 * skjermhøyder, settes klasse og ID på, og Lipscore bes om å tegne widgeten.
 * Brukes av snippets/lipscore-review-list.liquid (anmeldelseslisten nederst på produktsiden).
 *
 * RETTET 30.09.2026: plassholderen er 0 px høy før Lipscore fyller den, og IntersectionObserver rapporterte
 * den da aldri som synlig – listen ble aldri aktivert og ble stående tom (virket bare når siden ble lastet
 * med listen allerede i nærheten, f.eks. etter en oppdatering der nettleseren husker rulleposisjonen).
 * Nå:
 *   - synligheten følges på SEKSJONEN rundt plassholderen (har høyde), ikke på plassholderen selv
 *   - sikkerhetsnett: posisjonen sjekkes også ved rulling / endret vindusstørrelse
 *   - klikk på produktstjernene (åpner omtalevinduet) aktiverer listen med en gang
 *
 * Stjernene i Googles søkeresultater (snitt og antall) kommer fra stjernewidgeten øverst på siden og
 * påvirkes ikke. Er Lipscore ikke lastet ennå når klassen settes på, finner Lipscore widgeten selv når
 * scriptet starter (kontrollert 30.09.2026: sen aktivering + initWidgets tegner listen).
 */
(() => {
  if (window.__mmLipscoreLazy) return;
  window.__mmLipscoreLazy = true;

  const SELECTOR = '[data-mm-lipscore-lazy]';
  const PREFETCH_SCREENS = 1.5;
  let observer = null;
  const targetToElement = new Map();

  function renderWidgets() {
    try {
      if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
        window.lipscore.initWidgets();
      }
    } catch (error) {
      console.warn('Lipscore lazy init', error);
    }
  }

  function activate(element) {
    if (!element.hasAttribute('data-mm-lipscore-lazy')) return;
    const classes = (element.getAttribute('data-mm-lipscore-lazy') || '').split(/\s+/).filter(Boolean);
    const id = element.getAttribute('data-mm-lipscore-lazy-id');
    element.removeAttribute('data-mm-lipscore-lazy');
    element.removeAttribute('data-mm-lipscore-lazy-id');
    if (id && !document.getElementById(id)) element.id = id;
    if (classes.length > 0) element.classList.add(...classes);
    renderWidgets();
  }

  function activateAll() {
    document.querySelectorAll(SELECTOR).forEach(activate);
  }

  /* Elementet synligheten følges på: seksjonen rundt (har høyde), ellers nærmeste forelder med høyde. */
  function targetFor(element) {
    const section = element.closest('.shopify-section');
    if (section && section.getBoundingClientRect().height > 0) return section;
    let el = element.parentElement;
    while (el && el !== document.body && el.getBoundingClientRect().height === 0) el = el.parentElement;
    return el || element;
  }

  function nearViewport(element) {
    const rect = targetFor(element).getBoundingClientRect();
    const margin = window.innerHeight * PREFETCH_SCREENS;
    return rect.top < window.innerHeight + margin && rect.bottom > -margin;
  }

  let ticking = false;
  function checkPositions() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      document.querySelectorAll(SELECTOR).forEach((element) => {
        if (nearViewport(element)) activate(element);
      });
      if (!document.querySelector(SELECTOR)) {
        window.removeEventListener('scroll', checkPositions);
        window.removeEventListener('resize', checkPositions);
      }
    });
  }

  function start() {
    const elements = Array.from(document.querySelectorAll(SELECTOR));
    if (elements.length === 0) return;

    // En lenke rett til omtalene: tegn med en gang.
    if (/review|omtale|recension|anmeld/i.test(window.location.hash)) {
      elements.forEach(activate);
      return;
    }

    if (typeof IntersectionObserver !== 'undefined') {
      if (!observer) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const element = targetToElement.get(entry.target);
              if (element) activate(element);
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: `${PREFETCH_SCREENS * 100}% 0px` }
        );
      }
      elements.forEach((element) => {
        const target = targetFor(element);
        targetToElement.set(target, element);
        observer.observe(target);
      });
    }

    // Sikkerhetsnett: sjekk posisjonen direkte nå og ved rulling / endret størrelse.
    window.addEventListener('scroll', checkPositions, { passive: true });
    window.addEventListener('resize', checkPositions, { passive: true });
    checkPositions();
  }

  // Klikk på produktstjernene (åpner omtalevinduet): aktiver listen med en gang.
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest('#lipscore-rating, [data-mm-lipscore-product-reviews]')) {
        activateAll();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
